/* eslint-disable angular/timeout-service */
import { BaseController } from '~/utils/base-controller';

// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevMfController extends BaseController {
	/* @ngInject */
	constructor(
		/** @type {Knitiv.Angular.Injector} */
		$injector,
		/** @type {Knitiv.Scope} */
		$scope,
	) {
		super($injector);

		this.text = {
			quiz: {
				sport: {
					q1: {
						question: 'Which one is correct team name in NBA?',
						options: [
							'New York Bulls',
							'Los Angeles Kings',
							'Golden State Warriros',
							'Huston Rocket',
						],
						answer: 'Huston Rocket',
					},
				},
				maths: {
					q1: {
						question: '5 + 7 = ?',
						options: [
							'10',
							'11',
							'12',
							'13',
						],
						answer: '12',
					},
					q2: {
						question: '12 - 8 = ?',
						options: [
							'1',
							'2',
							'3',
							'4',
						],
						answer: '4',
					},
				},
			},
		};

		/** @type {string} */
		this.text2 = JSON.stringify(structuredClone(this.text), undefined, 2);

		$scope.$watch(() => this.text, () => {
			this.text2 = JSON.stringify(structuredClone(this.text), undefined, 2);
		});

		$scope.$watch(() => this.text2, () => {
			this.text = JSON.parse(this.text2);
		});

		this.editable = true;

		this.$onInit();
	}

	async $onInit() {
		//
	}
}
